// Mock data for development
export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      booking: "Book Now",
      reviews: "Reviews",
      contact: "Contact",
    },
    // Hero Section
    hero: {
      title: "Reliable Cleaning Services in Athens",
      subtitle: "Professional cleaning across Athens and surrounding areas. We make your space spotless with trusted, eco-friendly solutions.",
      cta: "Book a Viewing",
      phone: "Call Us",
    },
    // About Section
    about: {
      title: "About Nea Clean",
      description: "We are a professional cleaning company specializing in post-renovation cleaning, Airbnb turnovers, and commercial cleaning services. Our experienced team delivers exceptional results with attention to detail, using eco-friendly products and modern equipment.",
      why: "What makes us different:",
      points: [
        "Fully insured and trained cleaning teams",
        "Quick turnaround for urgent bookings",
        "Eco-friendly cleaning products",
        "Flexible scheduling to fit your needs",
        "100% satisfaction guarantee"
      ]
    },
    // Services Section
    services: {
      title: "Our Services",
      subtitle: "Professional cleaning solutions tailored to your needs",
      items: [
        {
          title: "Post-Renovation Cleaning",
          description: "Deep cleaning after construction or renovation work. We remove dust, debris, and leave your property spotless and ready to use."
        },
        {
          title: "Airbnb & Short-Stay Turnovers",
          description: "Fast and thorough cleaning between guest stays. We ensure your rental is pristine and welcoming for every new arrival."
        },
        {
          title: "Office & Commercial Cleaning",
          description: "Regular cleaning services for offices, shops, and commercial spaces. Keep your workplace professional and hygienic."
        }
      ]
    },
    // Booking Section
    booking: {
      title: "Book a Viewing",
      subtitle: "Schedule a free property viewing and get a personalized quote",
      form: {
        name: "Full Name",
        phone: "Phone Number",
        email: "Email Address",
        service: "Service Type",
        servicePlaceholder: "Select a service",
        date: "Preferred Date",
        time: "Preferred Time",
        address: "Property Address",
        postcode: "Post Code",
        message: "Additional Notes (Optional)",
        submit: "Request a Viewing",
        success: "Thank you! We'll contact you shortly to confirm your viewing.",
        error: "Something went wrong. Please try again or call us directly."
      },
      serviceOptions: [
        "Post-Renovation Cleaning",
        "Airbnb Turnover",
        "Office Cleaning",
        "Regular Cleaning",
        "Deep Cleaning",
        "Other"
      ]
    },
    // Reviews Section
    reviews: {
      title: "What Our Clients Say",
      subtitle: "Trusted by homeowners and businesses across Athens",
      items: [
        {
          name: "Maria K.",
          rating: 5,
          text: "They cleaned my apartment after renovation - everything was spotless! The team was on time and very thorough. Highly recommend.",
          service: "Post-Renovation Cleaning"
        },
        {
          name: "Dimitris P.",
          rating: 5,
          text: "We've been using them for our Airbnb for 6 months now. Always reliable and our guests constantly comment on how clean everything is.",
          service: "Airbnb Cleaning"
        },
        {
          name: "Thekla S.",
          rating: 4,
          text: "Good service overall. The team is friendly and our office looks much better. Would be 5 stars if they could come earlier in the day.",
          service: "Office Cleaning"
        },
        {
          name: "Kostas M.",
          rating: 5,
          text: "After our kitchen renovation there was dust everywhere. They came in and transformed the place in just a few hours. Very impressed!",
          service: "Post-Renovation Cleaning"
        },
        {
          name: "eleni t",
          rating: 5,
          text: "Quick turnaround between tenants is crucial for us. Nea Clean always delivers on time and does an excellent job.",
          service: "Airbnb Cleaning"
        },
        {
          name: "Giorgos",
          rating: 5,
          text: "Great cleaning service highly recomend",
          service: "Office Cleaning"
        }
      ]
    },
    // Why Choose Us Section
    whyChoose: {
      title: "Why Choose Nea Clean?",
      points: [
        {
          title: "Professional Teams",
          description: "Experienced, trained specialists dedicated to excellence"
        },
        {
          title: "Flexible Scheduling",
          description: "We work around your schedule, including weekends and holidays"
        },
        {
          title: "Professional Equipment",
          description: "High-quality products and modern cleaning equipment"
        },
        {
          title: "Satisfaction Guarantee",
          description: "We're not happy until you're happy with the results"
        },
        {
          title: "Competitive Pricing",
          description: "Transparent pricing with no hidden fees"
        },
        {
          title: "Quick Response",
          description: "Fast booking and same-day service available"
        }
      ]
    },
    // Contact Section
    contact: {
      title: "Get in Touch",
      subtitle: "We're here to help with all your cleaning needs",
      phone: "Phone",
      email: "Email",
      areas: "Service Areas",
      areasText: "Athens & Greater Athens Area",
      social: "Follow Us",
      copyright: "© 2021 Nea Clean. All rights reserved."
    },
    // Before/After Section
    beforeAfter: {
      title: "See Our Work in Action",
      subtitle: "Real transformations from our professional cleaning services",
      before: "Before",
      after: "After",
      categories: [
        "Post-Renovation Cleaning",
        "Deep Cleaning",
        "Office Cleaning"
      ]
    }
  },
  gr: {
    // Navigation
    nav: {
      home: "Αρχική",
      about: "Σχετικά",
      services: "Υπηρεσίες",
      booking: "Κράτηση",
      reviews: "Κριτικές",
      contact: "Επικοινωνία",
    },
    // Hero Section
    hero: {
      title: "Αξιόπιστες Υπηρεσίες Καθαρισμού στην Αθήνα",
      subtitle: "Επαγγελματικός καθαρισμός σε όλη την Αθήνα και τις γύρω περιοχές. Κάνουμε τον χώρο σας άψογο με αξιόπιστες, φιλικές προς το περιβάλλον λύσεις.",
      cta: "Κλείστε Ραντεβού",
      phone: "Καλέστε μας",
    },
    // About Section
    about: {
      title: "Σχετικά με την Nea Clean",
      description: "Είμαστε μια επαγγελματική εταιρεία καθαρισμού που ειδικεύεται σε καθαρισμό μετά από ανακαινίσεις, καθαρισμό Airbnb και εμπορικές υπηρεσίες καθαρισμού. Η έμπειρη ομάδα μας παρέχει εξαιρετικά αποτελέσματα με προσοχή στη λεπτομέρεια, χρησιμοποιώντας οικολογικά προϊόντα και σύγχρονο εξοπλισμό.",
      why: "Τι μας κάνει διαφορετικούς:",
      points: [
        "Πλήρως ασφαλισμένες και εκπαιδευμένες ομάδες καθαρισμού",
        "Γρήγορος χρόνος απόκρισης για επείγουσες κρατήσεις",
        "Οικολογικά προϊόντα καθαρισμού",
        "Ευέλικτος προγραμματισμός για τις ανάγκες σας",
        "100% εγγύηση ικανοποίησης"
      ]
    },
    // Services Section
    services: {
      title: "Οι Υπηρεσίες μας",
      subtitle: "Επαγγελματικές λύσεις καθαρισμού προσαρμοσμένες στις ανάγκες σας",
      items: [
        {
          title: "Καθαρισμός Μετά από Ανακαίνιση",
          description: "Βαθύς καθαρισμός μετά από οικοδομικές ή ανακαινιστικές εργασίες. Αφαιρούμε σκόνη, συντρίμμια και αφήνουμε το ακίνητό σας άψογο και έτοιμο για χρήση."
        },
        {
          title: "Καθαρισμός Airbnb & Βραχυχρόνιων Ενοικιάσεων",
          description: "Γρήγορος και διεξοδικός καθαρισμός μεταξύ των επισκέψεων των επισκεπτών. Διασφαλίζουμε ότι το ενοικιαζόμενό σας είναι άψογο και φιλόξενο για κάθε νέα άφιξη."
        },
        {
          title: "Καθαρισμός Γραφείων & Εμπορικών Χώρων",
          description: "Τακτικές υπηρεσίες καθαρισμού για γραφεία, καταστήματα και εμπορικούς χώρους. Διατηρήστε τον χώρο εργασίας σας επαγγελματικό και υγιεινό."
        }
      ]
    },
    // Booking Section
    booking: {
      title: "Κλείστε Ραντεβού",
      subtitle: "Προγραμματίστε μια δωρεάν επίσκεψη και λάβετε μια εξατομικευμένη προσφορά",
      form: {
        name: "Ονοματεπώνυμο",
        phone: "Τηλέφωνο",
        email: "Email",
        service: "Τύπος Υπηρεσίας",
        servicePlaceholder: "Επιλέξτε υπηρεσία",
        date: "Επιθυμητή Ημερομηνία",
        time: "Επιθυμητή Ώρα",
        address: "Διεύθυνση Ακινήτου",
        postcode: "Ταχυδρομικός Κώδικας",
        message: "Πρόσθετες Σημειώσεις (Προαιρετικό)",
        submit: "Αίτημα Επίσκεψης",
        success: "Ευχαριστούμε! Θα επικοινωνήσουμε μαζί σας σύντομα για επιβεβαίωση.",
        error: "Κάτι πήγε στραβά. Παρακαλούμε δοκιμάστε ξανά ή καλέστε μας απευθείας."
      },
      serviceOptions: [
        "Καθαρισμός Μετά από Ανακαίνιση",
        "Καθαρισμός Airbnb",
        "Καθαρισμός Γραφείων",
        "Τακτικός Καθαρισμός",
        "Βαθύς Καθαρισμός",
        "Άλλο"
      ]
    },
    // Reviews Section
    reviews: {
      title: "Τι Λένε οι Πελάτες μας",
      subtitle: "Εμπιστεύονται από ιδιοκτήτες σπιτιών και επιχειρήσεις σε όλη την Αθήνα",
      items: [
        {
          name: "Μαρία Κ.",
          rating: 5,
          text: "Καθάρισαν το διαμέρισμά μου μετά την ανακαίνιση - όλα ήταν άψογα! Η ομάδα ήταν στην ώρα της και πολύ προσεκτική. Τους συνιστώ ανεπιφύλακτα.",
          service: "Καθαρισμός Μετά από Ανακαίνιση"
        },
        {
          name: "Δημήτρης Π.",
          rating: 5,
          text: "Τους χρησιμοποιούμε για το Airbnb μας εδώ και 6 μήνες. Πάντα αξιόπιστοι και οι επισκέπτες μας σχολιάζουν συνεχώς πόσο καθαρά είναι όλα.",
          service: "Καθαρισμός Airbnb"
        },
        {
          name: "Θέκλα Σ.",
          rating: 4,
          text: "Καλή εξυπηρέτηση γενικά. Η ομάδα είναι φιλική και το γραφείο μας φαίνεται πολύ καλύτερα. Θα ήταν 5 αστέρια αν μπορούσαν να έρθουν νωρίτερα.",
          service: "Καθαρισμός Γραφείων"
        },
        {
          name: "Κώστας Μ.",
          rating: 5,
          text: "Μετά την ανακαίνιση της κουζίνας είχε σκόνη παντού. Ήρθαν και μεταμόρφωσαν τον χώρο σε λίγες ώρες. Πολύ εντυπωσιασμένος!",
          service: "Καθαρισμός Μετά από Ανακαίνιση"
        },
        {
          name: "ελενη τ",
          rating: 5,
          text: "Ο γρήγορος χρόνος απόκρισης μεταξύ ενοικιαστών είναι κρίσιμος για εμάς. Η Nea Clean πάντα παραδίδει στην ώρα και κάνει εξαιρετική δουλειά.",
          service: "Καθαρισμός Airbnb"
        },
        {
          name: "Γιώργος",
          rating: 5,
          text: "Πολύ καλή υπηρεσία, συνιστώ ανεπιφύλακτα",
          service: "Καθαρισμός Γραφείων"
        }
      ]
    },
    // Why Choose Us Section
    whyChoose: {
      title: "Γιατί να Επιλέξετε τη Nea Clean;",
      points: [
        {
          title: "Επαγγελματικές Ομάδες",
          description: "Έμπειροι, εκπαιδευμένοι ειδικοί αφοσιωμένοι στην αριστεία"
        },
        {
          title: "Ευέλικτος Προγραμματισμός",
          description: "Εργαζόμαστε σύμφωνα με το πρόγραμμά σας, συμπεριλαμβανομένων Σαββατοκυρίακων και αργιών"
        },
        {
          title: "Επαγγελματικός Εξοπλισμός",
          description: "Προϊόντα υψηλής ποιότητας και σύγχρονος εξοπλισμός καθαρισμού"
        },
        {
          title: "Εγγύηση Ικανοποίησης",
          description: "Δεν είμαστε ικανοποιημένοι μέχρι να είστε ευχαριστημένοι με τα αποτελέσματα"
        },
        {
          title: "Ανταγωνιστικές Τιμές",
          description: "Διαφανής τιμολόγηση χωρίς κρυφές χρεώσεις"
        },
        {
          title: "Γρήγορη Απόκριση",
          description: "Γρήγορη κράτηση και διαθεσιμότητα την ίδια μέρα"
        }
      ]
    },
    // Contact Section
    contact: {
      title: "Επικοινωνήστε μαζί μας",
      subtitle: "Είμαστε εδώ για να σας βοηθήσουμε με όλες τις ανάγκες καθαρισμού",
      phone: "Τηλέφωνο",
      email: "Email",
      areas: "Περιοχές Εξυπηρέτησης",
      areasText: "Αθήνα & Ευρύτερη Περιοχή Αθήνας",
      social: "Ακολουθήστε μας",
      copyright: "© 2021 Nea Clean. Όλα τα δικαιώματα διατηρούνται."
    },
    // Before/After Section
    beforeAfter: {
      title: "Δείτε τη Δουλειά μας σε Δράση",
      subtitle: "Πραγματικές μεταμορφώσεις από τις επαγγελματικές μας υπηρεσίες καθαρισμού",
      before: "Πριν",
      after: "Μετά",
      categories: [
        "Καθαρισμός Μετά από Ανακαίνιση",
        "Βαθύς Καθαρισμός",
        "Καθαρισμός Γραφείων"
      ]
    }
  }
};

export const mockBookings = [
  {
    id: "1",
    name: "Test User",
    phone: "+30 6994411844",
    email: "test@example.com",
    service: "Post-Renovation Cleaning",
    date: "2025-01-15",
    time: "10:00",
    address: "Athens, Greece",
    message: "This is a test booking",
    createdAt: "2025-01-10T10:00:00Z"
  }
];

// Images for the website
export const images = {
  hero: "https://customer-assets.emergentagent.com/job_shinenew/artifacts/eptw21wg_clean.jpg",
  logo: "https://customer-assets.emergentagent.com/job_a234996f-42ba-47eb-8e7e-ded163e33762/artifacts/hizsh1tg_image.png",
  employee: "https://customer-assets.emergentagent.com/job_shinenew/artifacts/84emc7q1_photo_2026-02-02_10-22-45.jpg",
  services: [
    "https://customer-assets.emergentagent.com/job_shinenew/artifacts/2kxtbmg8_photo_2026-02-02_10-22-55.jpg",
    "https://customer-assets.emergentagent.com/job_shinenew/artifacts/bgdirzm8_photo_2026-02-02_10-23-04.jpg",
    "https://customer-assets.emergentagent.com/job_shinenew/artifacts/d21hft49_photo_2026-02-02_10-23-09.jpg"
  ],
  cleanHomes: [
    "https://customer-assets.emergentagent.com/job_shinenew/artifacts/l5xfgopd_photo_2026-02-02_10-22-42.jpg",
    "https://customer-assets.emergentagent.com/job_shinenew/artifacts/bgdirzm8_photo_2026-02-02_10-23-04.jpg"
  ],
  gallery: [
    "https://customer-assets.emergentagent.com/job_shinenew/artifacts/l5xfgopd_photo_2026-02-02_10-22-42.jpg",
    "https://customer-assets.emergentagent.com/job_shinenew/artifacts/v6m1wkeg_photo_2026-02-02_10-22-45.jpg",
    "https://customer-assets.emergentagent.com/job_shinenew/artifacts/bgdirzm8_photo_2026-02-02_10-23-04.jpg",
    "https://customer-assets.emergentagent.com/job_shinenew/artifacts/bj00vrng_049f4b2f-af14-4264-87e7-7d3e4736d56a.jpg",
    "https://customer-assets.emergentagent.com/job_shinenew/artifacts/lzcczwqo_56f768ea-6067-4071-b27b-d4ac7b49571d.jpg",
    "https://customer-assets.emergentagent.com/job_shinenew/artifacts/sq6ncpn2_305fadd7-6dc8-4f39-adab-c01e2a136561.jpg",
    "https://customer-assets.emergentagent.com/job_shinenew/artifacts/xvb40pqp_5199d338-5cbb-4a8b-9b58-b8fdd38dae2e.jpg",
    "https://customer-assets.emergentagent.com/job_shinenew/artifacts/3efwuo55_before.jpg",
    "https://customer-assets.emergentagent.com/job_shinenew/artifacts/agngisv7_after.jpg"
  ],
  beforeAfter: [
    {
      before: "https://customer-assets.emergentagent.com/job_shinenew/artifacts/2kxtbmg8_photo_2026-02-02_10-22-55.jpg",
      after: "https://customer-assets.emergentagent.com/job_shinenew/artifacts/l5xfgopd_photo_2026-02-02_10-22-42.jpg"
    },
    {
      before: "https://customer-assets.emergentagent.com/job_shinenew/artifacts/d21hft49_photo_2026-02-02_10-23-09.jpg",
      after: "https://customer-assets.emergentagent.com/job_shinenew/artifacts/bgdirzm8_photo_2026-02-02_10-23-04.jpg"
    }
  ]
};

// Videos for the website
export const videos = [
  "https://customer-assets.emergentagent.com/job_shinenew/artifacts/0qi2dpu4_IMG_0343.MOV",
  "https://customer-assets.emergentagent.com/job_shinenew/artifacts/fe2edq03_IMG_0344.MOV"
];
